import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

enum Directions {
    Up,
    Down
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements AfterViewInit, OnChanges {
    @ViewChild('header') header;
    @Input() fixedTitle = false;
    @Input() scrollTolerance = 20;

    private initialized = false;
    private direction: Directions = Directions.Up;
    private ionContent: HTMLIonContentElement;

    ngAfterViewInit(): void {
        const header = this.header.nativeElement;
        this.ionContent = header.closest('ion-content');
        const stickyContent: HTMLElement = this.ionContent.querySelector('app-sticky-content');

        if (stickyContent) {
            const interval = setInterval(() => {
                const offsetHeight = header.offsetHeight;

                if (offsetHeight !== 0) {
                    stickyContent.style.position = 'sticky';
                    stickyContent.style.top = `${header.offsetHeight}px`;
                    stickyContent.style.left = '0';
                    clearInterval(interval);
                }
            }, 10);
        }

        this.checkForFixedTitle();

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.initialized && 'fixedTitle' in changes) {
            this.checkForFixedTitle();
        }
    }

    private checkForFixedTitle(): void {
        const header = this.header.nativeElement;
        const toolbarTitle = header.querySelector('app-toolbar')?.querySelector('.title');
        const contentTitle = this.ionContent.querySelector('app-content-title')?.querySelector('.flow-content-title');
        let previousPoint = 0;

        if (!this.fixedTitle) {
            this.ionContent.scrollEvents = true;
            this.expandTitle(contentTitle, toolbarTitle);

            this.ionContent.addEventListener('ionScroll', (e: CustomEvent) => {
                // Calculate the current scroll direction
                if (e.detail.scrollTop > previousPoint) {
                    this.direction = Directions.Up;
                } else {
                    this.direction = Directions.Down;
                }

                previousPoint = e.detail.scrollTop;

                // Check if title should be expanded or collapsed
                if (!this.fixedTitle) {
                    if (e.detail.scrollTop >= this.scrollTolerance) {
                        this.shrinkTitle(contentTitle, toolbarTitle);
                    } else {
                        this.expandTitle(contentTitle, toolbarTitle);
                    }
                }
            });
        } else{
            this.shrinkTitle(contentTitle, toolbarTitle);
        }
    }

    private expandTitle(contentTitle, toolbarTitle): void {
        contentTitle?.classList.remove('invisible');
        toolbarTitle?.classList.remove('visible');
    }

    private shrinkTitle(contentTitle, toolbarTitle): void {
        contentTitle?.classList.add('invisible');
        toolbarTitle?.classList.add('visible');
    }
}
